import React from "react";
import Loading from "@/common/components/Loading";
import PopUp from "@/common/components/PopUp";
import { Title } from "../../AdminCommandPage.styled";
import { STEPS, WIZARD_STEP } from "./constants";
import useAddLanguageWizard from "./hooks/useAddLanguageWizard";
import WizardSteps from "./components/WizardSteps";
import StepAddLanguage from "./components/StepAddLanguage";
import StepCopyLessons from "./components/StepCopyLessons";
import StepImportDatabase from "./components/StepImportDatabase";
import StepMarkWords from "./components/StepMarkWords";

const AddLanguageWizard = ({ setClose, reloadMutation }) => {
  const {
    step,
    setStep,
    languageMode,
    setLanguageMode,
    languagesOptions,
    selectedExisting,
    setSelectedExisting,
    selectedDelimiter,
    setSelectedDelimiter,
    voices,
    setVoices,
    nameRef,
    shortNameRef,
    isLangToRef,
    csvFileRef,
    targetLanguage,
    isLoading,
    handleClose,
    handleStepOneBack,
    handleCreateLanguage,
    handleDuplicateLessons,
    handleImportDatabase,
    handleMarkWordsAsUser,
  } = useAddLanguageWizard({ setClose, reloadMutation });

  return (
    <>
      {isLoading && <Loading />}
      <PopUp setClose={setClose}>
        <Title>
          Add language — step {step} / {STEPS.length}
        </Title>
        <WizardSteps step={step} />
        {step === WIZARD_STEP.ADD_LANGUAGE && (
          <StepAddLanguage
            languageMode={languageMode}
            setLanguageMode={setLanguageMode}
            languagesOptions={languagesOptions}
            selectedExisting={selectedExisting}
            setSelectedExisting={setSelectedExisting}
            nameRef={nameRef}
            shortNameRef={shortNameRef}
            isLangToRef={isLangToRef}
            voices={voices}
            setVoices={setVoices}
            handleStepOneBack={handleStepOneBack}
            handleCreateLanguage={handleCreateLanguage}
          />
        )}
        {step === WIZARD_STEP.COPY_LESSONS && (
          <StepCopyLessons
            targetLanguage={targetLanguage}
            setStep={setStep}
            handleDuplicateLessons={handleDuplicateLessons}
          />
        )}
        {step === WIZARD_STEP.IMPORT_DATABASE && (
          <StepImportDatabase
            targetLanguage={targetLanguage}
            csvFileRef={csvFileRef}
            selectedDelimiter={selectedDelimiter}
            setSelectedDelimiter={setSelectedDelimiter}
            setStep={setStep}
            handleImportDatabase={handleImportDatabase}
          />
        )}
        {step === WIZARD_STEP.MARK_WORDS && (
          <StepMarkWords
            targetLanguage={targetLanguage}
            setStep={setStep}
            handleMarkWordsAsUser={handleMarkWordsAsUser}
            handleClose={handleClose}
          />
        )}
      </PopUp>
    </>
  );
};

export default AddLanguageWizard;
